import { Alert, Typography } from "@carrotfertility/carotene-core"
import React from "react"
import { FormattedMessage } from "react-intl"

export function PartnerHasScheduledServicesAlert({ scheduledServices }: { scheduledServices: any }): JSX.Element {
  return (
    <Alert severity="info">
      <Typography>
        {scheduledServices?.[0]?.clinicName ? (
          <FormattedMessage
            defaultMessage="Some partner details can’t be updated because they have a service in progress with {clinicName}. Contact the clinic if you need to cancel this service."
            values={{
              clinicName: scheduledServices?.[0]?.clinicName
            }}
          />
        ) : (
          <FormattedMessage defaultMessage="Some partner details can’t be updated because they have a service in progress with a clinic. Contact the clinic if you need to cancel this service." />
        )}
      </Typography>
    </Alert>
  )
}
